export * from "./RecordCardCommonBox";
